import axios from '../api/axiosConfig';

export interface EmotionRecord {
  _id: string;
  value: number;
  createdAt: string;
}

export const saveEmotion = async (value: number): Promise<EmotionRecord> => {
  const response = await axios.post('/api/emotions', { value });
  return response.data;
};

export const getEmotions = async (): Promise<EmotionRecord[]> => {
  const response = await axios.get('/api/emotions');
  return response.data;
};
